import React from "react";
import FirstDraft from "../modules/FirstDraft/FirstDraft.jsx";

const Firstdraft = () => {
	return <FirstDraft />;
};

export default Firstdraft;